export default {
  GET_SCHEDULES_BY_TEAM: "Team work schedules retrieved successfully",
  SET_SCHEDULES_BY_TEAM: "Team work schedules updated successfully",

  ERROR_GETTING_WORK_SCHEDULES: "There was an error retrieving the work schedules",
  ERROR_UPDATING_WORK_SCHEDULES: "There was an error updating your work schedules",
};
